var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"desk",style:({
    '--grid-size': _vm.grid,
  })},_vm._l((_vm.game.cardState),function(card,i){return _c('card',{key:i,attrs:{"index":parseInt(i),"src":_vm.deckMap[i],"turned":card != 0,"collected":card > 0}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }